import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { graphqlProvider } from './core/graphql/graphql.provider';
import { TranslocoHttpLoader } from './core/language/transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { browserLang } from './core/language/transloco.utills';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    graphqlProvider,
    provideHttpClient(),
    provideTransloco({
      config: {
        availableLangs: ['en', 'ko'],
        defaultLang: browserLang(),
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
